import PonesiLoader from "./PonesiLoader";

// Kept as the historical import path: every consumer now renders the official Ponesi loader.
export default function Loader() {
  return <PonesiLoader />;
}
